import { Injectable } from "@angular/core";
import { DwContextService, DwEventService, DwExpressionService, DwMenu, DwMenuExpressionProcessorService, DwSecurityStateService, DwSecurityUserService } from "@devwareapps/devware-cap";
import { forkJoin, Subject } from "rxjs";
import { SchoolRepositoryService } from "./features/schools/services/school-repository.service";
import { AdminManagerService } from "./features/shared/services/admin-manager.service";
import { PilexosUserTypeIds } from "./features/shared/models/pilexos-user-type.enum";
import { SchoolFeatures } from "./features/schools/models/school-features.model";
import { FlightSchoolExaminerTrainingStatus } from "./features/schools/models/flight-school-examiner-training-status.model";
import { distinctUntilChanged, map, switchMap } from "rxjs/operators";
import { of } from "rxjs";

@Injectable()
export class PileoxsMenuProcessorService extends DwMenuExpressionProcessorService {

    protected dwUserSecurityService2: DwSecurityUserService;
    schoolFeatures: SchoolFeatures;
    examinerTrainingStatus: FlightSchoolExaminerTrainingStatus;

    constructor(dwExpressionSevice: DwExpressionService,
        dwEventService: DwEventService,
        dwContextService: DwContextService,
        dwUserSecurityService: DwSecurityUserService,
        private dwSecurityStateService: DwSecurityStateService,
        private adminManagerService: AdminManagerService,
        private schoolRepositoryService: SchoolRepositoryService
    ) {
        super(dwExpressionSevice, dwEventService, dwContextService, dwUserSecurityService);

    }

    processAllMenus(menus: DwMenu[]): DwMenu[] {
        var pilexosUser = this.adminManagerService.getPilexosUser();

        let poaMenuDispaly = 'Exam QMS';
        let poaPlansMenuDispaly = 'Plans Of Action';

        if (pilexosUser.UserTypeId == PilexosUserTypeIds.pilotExaminer) {
            poaMenuDispaly = 'Plan Of Action';
            poaPlansMenuDispaly = 'Plans';
        }

        const poaMenu = this.updateMenu(menus, 'plan-of-action', poaMenuDispaly);
        if (poaMenu) {
            const plansMenu = this.updateMenu(poaMenu.children || [], 'plans', poaPlansMenuDispaly);
            this.updatePlanOfActionAddVisibility(plansMenu);
        }

        return menus;
    }

    private updateMenu(menus: DwMenu[], path: string, display: string) : DwMenu {
        // if (parentPath) {
        //     let parentMenu = menus.find(m => m.path == parentPath);
        //     menus = parentMenu?.children || [];
        // }

        var menu = menus.find(m => m.path == path);

        if (menu) {
            menu.display = display;
            console.log('Updating menu ' + display);
        }

        return menu;
    }

    private updatePlanOfActionAddVisibility(plansMenu: DwMenu) {
        if (!plansMenu?.children?.length) {
            return;
        }

        const hideAdd = this.examinerTrainingStatus?.ValidateExaminerTrainingForPOA === true &&
            this.examinerTrainingStatus?.IsTrainingValidationApplicable === true &&
            this.examinerTrainingStatus?.HasMetAllRequiredTraining === false;

        if (!hideAdd) {
            return;
        }

        plansMenu.children = plansMenu.children.filter(menu => {
            const actionType = (menu?.data?.metaDataActionType || '').toString().toLowerCase();
            return actionType !== 'add';
        });
    }

    refreshSetupComplete = false;

    setupMenuRefresh(refreshSubject: Subject<any>, contextNames: string[]) {
        super.setupMenuRefresh(refreshSubject, contextNames);

        if (this.refreshSetupComplete) {
            return;
        }
        this.refreshSetupComplete = true;

        console.log('Setting up menu refresh for security context changes');
        this.dwSecurityStateService.securityContextChanged()
            .pipe(map((securityContext) => {
                return securityContext?.ApplicationUser?.UserId
            }), distinctUntilChanged(),
                switchMap(userId => {
                    const pilexosUser = this.adminManagerService.getPilexosUser();
                    const validTrainingUserTypes = [PilexosUserTypeIds.flightInstructor, PilexosUserTypeIds.checkInstructor];
                    const shouldLoadTrainingStatus = !!pilexosUser?.user?.UserId && validTrainingUserTypes.includes(pilexosUser?.UserTypeId);

                    return forkJoin({
                        schoolFeatures: this.schoolRepositoryService.getSchoolFeatures(),
                        examinerTrainingStatus: shouldLoadTrainingStatus
                            ? this.schoolRepositoryService.getFlightSchoolExaminerTrainingStatus()
                            : of({} as FlightSchoolExaminerTrainingStatus)
                    });

                }))
            .subscribe(result => {
                this.schoolFeatures = result.schoolFeatures;
                this.examinerTrainingStatus = result.examinerTrainingStatus;

                refreshSubject.next(true);
            });
    }

}
